import { ACCEPTED_FILE_TYPES } from './schema'

export const facilitationFormFields = [
  //   {
  //     name: 'gender',
  //     label: 'Gender',
  //     type: 'custom_select',
  //     required: true,
  //     disabled: false,
  //     placeholder: 'Select Gender',
  //     id: 'gender',
  //     desc: 'label',
  //     descId: 'value',
  //     data: [
  //       { label: 'Male', value: 'Male' },
  //       { label: 'Female', value: 'Female' },
  //       { label: 'Other', value: 'Other' },
  //     ],
  //   },

  {
    name: 'gender_name',
    label: 'Select Gender',
    type: 'custom_select',
    placeholder: 'Select Gender',
    required: true,
    disabled: false,
    desc: 'name',
    descId: 'id',
    id: 'gender',
    data: [
      { name: 'Male', id: 'Male' },
      { name: 'Female', id: 'Female' },
      { name: 'Other', id: 'Other' },
    ],
  },

  // {
  //     name: 'role_name' as const,
  //     label: 'Role',
  //     type: 'custom_select' as const,
  //     placeholder: 'Select Role',
  //     required: true,
  //     disabled: false,
  //     desc: 'name',
  //     descId: 'id',
  //     id: 'role',
  //     data: [
  //       { name: 'Aspiring Entrepreneur', id: '1' },
  //       { name: 'Schools And Colleges', id: '2' },
  //       { name: 'Research Institutions And Universities', id: '3' },
  //       { name: 'Existing Entrepreneurs', id: '4' },
  //       { name: 'Industry Associations / Enablers', id: '5' },
  //       { name: 'Experts / Mentor', id: '6' },
  //       { name: 'Ed Club', id: '7' },
  //       { name: 'Students', id: '8' },
  //       { name: 'Guest', id: '9' },
  //     ],
  //   },

  {
    name: 'social_category_name',
    label: 'Social Category',
    type: 'custom_select',
    required: true,
    disabled: false,
    placeholder: 'Select Category',
    id: 'social_category',
    desc: 'name',
    descId: 'id',
    data: [
      { name: 'General', id: 'General' },
      { name: 'OBC', id: 'OBC' },
      { name: 'SC', id: 'SC' },
      { name: 'ST', id: 'ST' },
    ],
  },
  {
    name: 'age',
    label: 'Age',
    type: 'number',
    required: true,
    disabled: false,
  },
  {
    name: 'attended_kied_training',
    label: 'Attended KIED Training?',
    type: 'radio',
    required: true,
    data: [
      { id: 1, radioLabel: 'Yes', value: '1' },
      { id: 2, radioLabel: 'No', value: '0' },
    ],
    disabled: false,
  },
  {
    name: 'training_names',
    label: 'Training Name(s)',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'training_period',
    label: 'Training Period',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'enterprise_name',
    label: 'Enterprise Name',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'enterprise_address',
    label: 'Enterprise Address',
    type: 'textarea',
    required: true,
    disabled: false,
  },
  {
    name: 'business_type',
    label: 'Business Type',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'business_activity',
    label: 'Business Activity',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'products_or_services',
    label: 'Products or Services Offered',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'service_type',
    label: 'Service Type Availed',
    type: 'text',
    required: true,
    disabled: false,
  },
  {
    name: 'service_description',
    label: 'Description of Service Availed',
    type: 'textarea',
    required: true,
    disabled: false,
  },
  {
    name: 'uploaded_document',
    label: 'Upload Document',
    type: 'file_upload',
    required: true,
    id: 'uploaded_document',
    selectedFiles: [],
    descId: 'id',
    supportedExtensions: ACCEPTED_FILE_TYPES,
    supportedFiles: ACCEPTED_FILE_TYPES,
    acceptedFiles: 'Upload .pdf only',
    value: null,
    needConfirmation: true,
    disabled: false,
  },
]
